var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 7.75C20.17 7.75 19.67 7.425 19.42 6.945L15.4 10.6L12.76 6.54C12.54 6.675 12.28 6.75 12 6.75C11.72 6.75 11.46 6.675 11.24 6.54L8.59997 10.6L4.57997 6.945C4.32997 7.425 3.82997 7.75 3.24997 7.75C3.03997 7.75 2.83997 7.705 2.65997 7.63L4.49997 16.825V19.25C4.49997 20.215 5.28497 21 6.24997 21H17.75C18.715 21 19.5 20.215 19.5 19.25V16.825L21.34 7.63C21.16 7.705 20.96 7.75 20.75 7.75ZM18.015 16.605C18.005 16.65 18 16.7 18 16.75V19.25C18 19.39 17.89 19.5 17.75 19.5H6.24997C6.10997 19.5 5.99997 19.39 5.99997 19.25V16.75C5.99997 16.7 5.99497 16.65 5.98497 16.605L4.43497 8.84L8.24497 12.305C8.40997 12.455 8.62997 12.525 8.84497 12.495C9.06497 12.465 9.25997 12.345 9.37997 12.16L12 8.125L14.62 12.16C14.74 12.345 14.935 12.465 15.155 12.495C15.375 12.525 15.59 12.455 15.755 12.305L19.565 8.84L18.015 16.605Z",
    fill: "#E0E0E0",
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 7.75C4.07843 7.75 4.75 7.07843 4.75 6.25C4.75 5.42157 4.07843 4.75 3.25 4.75C2.42157 4.75 1.75 5.42157 1.75 6.25C1.75 7.07843 2.42157 7.75 3.25 7.75Z",
    fill: "#E0E0E0",
    stroke: "#E0E0E0",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 7.75C21.5784 7.75 22.25 7.07843 22.25 6.25C22.25 5.42157 21.5784 4.75 20.75 4.75C19.9216 4.75 19.25 5.42157 19.25 6.25C19.25 7.07843 19.9216 7.75 20.75 7.75Z",
    fill: "#E0E0E0",
    stroke: "#E0E0E0",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.75C12.8284 6.75 13.5 6.07843 13.5 5.25C13.5 4.42157 12.8284 3.75 12 3.75C11.1716 3.75 10.5 4.42157 10.5 5.25C10.5 6.07843 11.1716 6.75 12 6.75Z",
    fill: "#E0E0E0",
    stroke: "#E0E0E0",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.ef88dcef959945f48aecc7380919009a.svg";
export { ForwardRef as ReactComponent };